import React from 'react';
import Head from 'next/head';
import fs from 'fs';
import path from 'path';

import Layout from '../components/Layout';
import AboutUs from '../components/AboutUs';

const About = ({ content }) => (
  <Layout page="About">
    <Head>
      {content?.meta?.title && <title>{content.meta.title}</title>}
      {content?.meta?.description && (
        <meta
          data-hid="twitterDescription"
          name="twitter:description"
          content={content.meta.description}
        />
      )}
      {content?.meta?.description && (
        <meta name="description" content={content.meta.description} />
      )}
      {content?.meta?.description && (
        <meta name="keywords" content={content.meta.keywords} />
      )}
      <meta
        property="og:image"
        content={`${process.env.NEXT_PUBLIC_CDN}${
          content?.meta?.image
            ? content?.meta?.image
            : '/images/metaImage/default.jpg'
        }`}
      ></meta>
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="oneistox.com" />
      <meta property="twitter:url" content="https://www.oneistox.com/about" />
      <meta name="twitter:title" content="About - Oneistox.in" />
      <meta
        name="twitter:description"
        content="Our mission drives us to build the Design University of the Future. It all started with us with a goal to. We do this by creating online courses for designers to upskill at every stage of their career, by teaching relevant skills that get designers better professional growth and by building a community of designers that can help each other be infinite learners."
      ></meta>
      <meta
        name="twitter:image"
        content={`${process.env.NEXT_PUBLIC_CDN}${
          content?.meta?.image
            ? content?.meta?.image
            : '/images/metaImage/default.jpg'
        }`}
      />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="627" />
      <meta property="og:image:alt" content={content?.meta?.title} />
    </Head>
    <AboutUs data={content} />
  </Layout>
);

export const getStaticProps = async () => {
  const content = fs.readFileSync(path.join('content/about.json')).toString();

  return { props: { content: JSON.parse(content) } };
};

export default About;
